/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import UpdateContactBreadcrumbs from 'domain/sales/contact/createupdate/Update/Breadcrumbs';
import useContactService from 'domain/sales/contact/shared/contactService';
import ContactForm from 'domain/sales/contact/createupdate/ContactForm';
import useErrorMap from 'domain/sales/contact/createupdate/errorHandlers';
import { useContactUrl } from 'domain/sales/contact/contactRouting';

const UpdateContact = () => {
  const { update, getById, getValidationSchema } = useContactService();
  const { errorsMap } = useErrorMap();
  const { getSingleEntityUrl } = useContactUrl();

  return (
    <UpdateForm
      submitFormFunc={update}
      getDataFunc={getById}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Contact has been successfully saved.',
      }}
      errorsMap={errorsMap}
    >
      <UpdatePageLayout title="Edit: Contact" breadcrumbs={<UpdateContactBreadcrumbs />}>
        <ContactForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateContact;
